import styled from 'styled-components';
import { breakpoint } from '../theme/breakpoint';

export const StyleWrapper = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.palette.lightBackground};
  padding: ${({ theme }) => theme.spacing.medium};
  margin-bottom: ${({ theme }) => theme.spacing.medium};
  box-shadow: ${({ theme }) => theme.boxshadow.small};

  &:hover {
    box-shadow: ${({ theme }) => theme.boxshadow.standard};
  }

  ${breakpoint.tablet`
     max-width: 380px;
   `};
`;

export const SurveyWrapper = styled.div`
  display: flex;
  place-content: center;
`;
